/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface QuestionnaireAssessment
 */
export interface QuestionnaireAssessment {
  /**
   *
   * @type {number}
   * @memberof QuestionnaireAssessment
   */
  readonly id: number;
  /**
   *
   * @type {Date}
   * @memberof QuestionnaireAssessment
   */
  timestamp?: Date;
}

/**
 * Check if a given object implements the QuestionnaireAssessment interface.
 */
export function instanceOfQuestionnaireAssessment(value: object): value is QuestionnaireAssessment {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function QuestionnaireAssessmentFromJSON(json: any): QuestionnaireAssessment {
  return QuestionnaireAssessmentFromJSONTyped(json, false);
}

export function QuestionnaireAssessmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireAssessment {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
  };
}

export function QuestionnaireAssessmentToJSON(value?: Omit<QuestionnaireAssessment, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
  };
}
